import { useSelector } from 'react-redux';
import Input from './inputs/input';
import React from 'react';
import { Oval } from 'react-loader-spinner';

const Form = ({ fields, fieldsExist }) => {
  const formSubmitInvalidSlug = useSelector(
    (state) => state.orgInformation.formSubmitInvalidSlug,
  );
  const isSubmitting = useSelector(
    (state) => state.generic.loading,
  );

  return (
    <>
      {Object.keys(fields).map((key) => (
        <React.Fragment key={key}>
          <Input
            data={fields[key]}
            key={key}
            showSubmitFieldError={formSubmitInvalidSlug === fields[key].slug}
            disabled={isSubmitting}
          />
        </React.Fragment>
      ))}
      {fieldsExist && (
        <div className="flex justify-center">
          <button
            type="submit"
            disabled={isSubmitting}
            className="inline-block transition duration-300 uppercase bg-red text-white button-solid hover:opacity-80 flex items-center justify-center"
            style={{ minWidth: '120px', minHeight: '48px', ...(isSubmitting ? { opacity: 0.7, cursor: 'not-allowed' } : {}) }}
          >
            {isSubmitting ? (
              <Oval
                height={20}
                width={20}
                color="#ffffff"
                secondaryColor="#ffffff"
                strokeWidth={4}
                strokeWidthSecondary={4}
              />
            ) : (
              'Submit'
            )}
          </button>
        </div>
      )}
    </>
  );
};

export default Form;
